export default __webpack_public_path__ + "static/media/audio_11_gallo.bb240d59.mp3";